import { I18n } from "aws-amplify";
import { buildListCategoriesMessage, buildListTagFieldMessage, buildListTicketMessage, buildMessageSuggestUsingAI, checkMessageOutOfSession, createMessageList, filterFieldHasNoTicketOption, getListTicketAfterSelectedOption, getListTicketOfSelectedTagField, postMessage} from "./handler/ChatBoxHandler";
import Utils from "@/common/utils/utils";
import { memo, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { updatePreviewSettingAtom } from "@/state/atom/chatBotPreview";
import TicketImagePreviewList from "./TicketImagePreviewList";
import DisplayOptionBySetting from "./DisplayOptionBySetting";
import { getOptionDisplayLength } from './handler/ChatBoxHandler';



function ListTagFieldItem(props) {

    let {message,onClickHandler,chatbotSettings,messages,setMessages, usingAI,listTagFieldSkip,setListTagFieldSkip,enableListTicket,getMessage,resolvedMessages} = props;
    let {listTagFieldSelected,filterPublicKnowledge,listSelectedItemOfSession,listTicketIdBeforeFilter,listTagFieldOfSelectedCategory,setListTicketIdBeforeFilterTagField,handleWhenRenderTagFieldPriority, listTagItemSelected} = props;
    let {setListKnowledgeTicketId,supportThreadIdState,affiliationOrganization,setListTagFieldSelected} = props;
    let {isModePreview,listCategories} = props
    const [maxNumberAnswer,setMaxNumberAnswer] = useState(0);
    const [useImageInAnswer,setUseImageAnswer] = useState(false)
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [messageState, setMessagesState] = useState(message)
    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    useEffect(() => {
        if (!isModePreview) {
            setMaxNumberAnswer(chatbotSettings.maxNumberAnswer);
            setUseImageAnswer(chatbotSettings.useImageInAnswer)
        }
    }, [chatbotSettings]);

    useEffect(() => {
        if (isModePreview) {
            if (previewSetting.maxNumberAnswer !== maxNumberAnswer) {
                setMaxNumberAnswer(previewSetting.maxNumberAnswer);
            }
            if(useImageInAnswer !== previewSetting.useImageInAnswer){
                setUseImageAnswer(previewSetting.useImageInAnswer)
            }
        }
    }, [previewSetting]);
    
    let isShowSeeMore = maxNumberAnswer < messageState?.content?.length;

    const onClickSkipHandler = idOfMessage => {
        if (checkMessageOutOfSession(messages, idOfMessage)) return;
        const itemList = messageState.content;
        const idOfTagField = itemList[0]?.idOfTagField
        if(idOfTagField){
            setListTagFieldSkip(pev => [...pev, idOfTagField])
        }

        // let listTagFieldNotSelect = listTagFieldOfSelectedCategory?.filter(tagField => {
        //     return !listTagFieldSelected.includes(tagField.id);
        // });

        let listTagFieldNotSelect = [...listTagFieldOfSelectedCategory];
        let listTagItemSelectedInDB = !Utils.isEmptyArray(message?.listTagItemSelected) ? message?.listTagItemSelected : [];

        let listFieldValid = filterFieldHasNoTicketOption(listTagFieldNotSelect,listTicketIdBeforeFilter,listTagFieldSelected, [...listTagItemSelectedInDB, ...listTagItemSelected]);
        listFieldValid = listFieldValid?.filter(field => field.id !== idOfTagField && !listTagFieldSkip.includes(field.id))

        if (listFieldValid.length === 0) {
            const ticketMessage = enableListTicket ? buildListTicketMessage(
                filterPublicKnowledge.tagFieldSelected,
                messages.length,
                listSelectedItemOfSession,
                usingAI
            ) : buildMessageSuggestUsingAI(messages.length, resolvedMessages);

            setMessages([...messages, ticketMessage]);

        } else {
            let newMessage = {};
            setListKnowledgeTicketId([...listTicketIdBeforeFilter]);
            if(listFieldValid[0].priority || listFieldValid.length === 1){
                const listTicketIdOfField = getListTicketOfSelectedTagField(listFieldValid[0]);
                setListTicketIdBeforeFilterTagField([...listTicketIdBeforeFilter]);
                const listTicketAfterSelectedField = getListTicketAfterSelectedOption(
                    listTicketIdBeforeFilter,
                    listTicketIdOfField
                );

                setListTagFieldSelected(prev => [...prev,listFieldValid[0].id])
                newMessage = handleWhenRenderTagFieldPriority(listFieldValid[0],listTicketAfterSelectedField, false, [...listTagItemSelectedInDB, ...listTagItemSelected])
            }

            if(!listFieldValid[0].priority && listFieldValid.length !== 1){
                newMessage = buildListTagFieldMessage(listFieldValid,listTagFieldSelected,1,false, usingAI, listTagFieldSelected, listTagItemSelected) 
            }
            createMessageList([newMessage],supportThreadIdState,
                affiliationOrganization,isModePreview)
            setMessages([...messages, newMessage]);
        }
    };

    const onClickBackToListFormHandler = () => {
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const nextMessage = buildListCategoriesMessage(listCategories);
        postMessage(
            nextMessage,
            supportThreadIdState,
            affiliationOrganization,
            false,
            isModePreview
        );
        setMessages(pev => [...pev, nextMessage]);
    };
    
    return (
        <div className={props.isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'}>
            <div className="text-question text-question-tag-item">{
                getMessage(
                    messageState?.usingAI ? 'bot_selection_prompt_ai' : 'bot_selection_prompt',
                    { SelectedItem: messageState?.nameOption }
                )
            }</div>
            {messageState?.content?.slice(0, maxNumberAnswer)?.map(option => {
                if (Utils.isEmptyString(option.firstImage) || !useImageInAnswer) {
                    return <DisplayOptionBySetting 
                        key={option.id}
                        label={option.name}
                        optionDisplayLength={getOptionDisplayLength(chatbotSettings, previewSetting)}
                        onClickHandler={() => onClickHandler(option, messageState.idMessage)}
                        isMaximizedPanel={props?.isMaximizedPanel}
                    />
                    // return <OverFlowTooltipWithTabsMui
                    //     className={`option-form ${props?.isMaximizedPanel ? 'maximized-form': 'minimized-form'}`}
                    //     onClick={e => {
                    //         onClickHandler(option, messageState.idMessage);
                    //     }}
                    //     value={option.name}
                    //     key={option.id}
                    // />;
                } else {
                    return (
                        <TicketImagePreviewList
                            onClick={e => {
                                onClickHandler(option, messageState.idMessage);
                            }}
                            label={option.name}
                            urlKey={option.firstImage}
                            idMessage={messageState.idMessage}
                            chatbotSettings={chatbotSettings}
                            previewSetting={previewSetting}
                            isMaximizedPanel={props?.isMaximizedPanel}
                        />
                    );
                }
            })}
            {isShowSeeMore && <div className="option-seemore">{getMessage('bot_other_options_hint')}</div>}
            <div className="btn-func-container">
                {messageState.isDisplayBackBtn && (
                    <div className="btn-back-tagfield" onClick={onClickBackToListFormHandler}>
                        {/* <img src="/assets/image/icon-back-chatbot.svg" alt="sss" /> */}
                        <span className="text-btn-back">{getMessage('bot_back_button_label')}</span>
                    </div>
                )}
                <div
                    className="btn-skip-tagfield"
                    onClick={() => onClickSkipHandler(messageState.idMessage)}
                >
                    <span className="text-btn-skip">{getMessage('bot_skip_button_label')}</span>
                    {/* <img src="/assets/image/icon-skip-chatbot.svg" alt="sss" /> */}
                </div>
            </div>
        </div>
    );
}

export default memo(ListTagFieldItem)